import apolloClient, { ApolloProvider } from 'Utils/apolloClient'
import CalendarBlock from 'Shared/CalendarBlock/Components/CalendarBlock'
import ErrorBoundary from 'Shared/ErrorBoundary/ErrorBoundary'

const App = () => {
  const container = document.getElementById('calendar-block-container')
  window.roverData = { ...window.roverData, ...container.dataset }
  const isEngineAdmin = window.roverData.admin === 'true'

  return (
    <ApolloProvider client={apolloClient}>
      <ErrorBoundary>
        <CalendarBlock isEngineAdmin={isEngineAdmin} />
      </ErrorBoundary>
    </ApolloProvider>
  )
}

export default App
